import React from "react";

import { Subscribe } from "unstated";

import { ProfileContainer } from "./containers/profile-container";

import { Form } from "react-final-form";
import { FORM_ERROR } from "final-form";

import { FormErrors } from "../components/ui/form-errors";

import _ from "lodash";

import { stateList } from "../lib/state-utilities";

import { AddressFields } from "./address-fields";

const filterAddressInput = (values) =>
  _.pick(values, [
    "streetPrimary",
    "streetSecondary",
    "city",
    "state",
    "postalCode"
  ]);

const onCreateSubmit = (profileContainer, addressTypeId) => async (values) => {
  const params = filterAddressInput(values);

  params.addressTypeId = addressTypeId;

  return profileContainer.createAddress(params).catch(() => {
    return { [FORM_ERROR]: "Failed to create Address" };
  });
};

const onUpdateSubmit = (profileContainer, addressTypeId, addressId) => async (
  values
) => {
  const params = filterAddressInput(values);

  params.addressTypeId = addressTypeId;

  return profileContainer.updateAddress(addressId, params).catch(() => {
    return { [FORM_ERROR]: "Failed to update Address" };
  });
};

const AddressUpdate = ({ address }) => {
  return (
    <Subscribe to={[ProfileContainer]}>
      {(profileContainer) => (
        <React.Fragment>
          <h5>{address.addressTypeDescription} ADDRESS</h5>
          <Form
            onSubmit={
              _.isNil(address.id)
                ? onCreateSubmit(profileContainer, address.addressTypeId)
                : onUpdateSubmit(
                    profileContainer,
                    address.addressTypeId,
                    address.id
                  )
            }
            initialValues={address}
            render={({
              handleSubmit,
              submitting,
              submitError,
              dirtySinceLastSubmit
            }) => (
              <form onSubmit={handleSubmit}>
                <AddressFields states={stateList(address.addressTypeId)()} />

                <FormErrors
                  submitError={submitError}
                  dirtySinceLastSubmit={dirtySinceLastSubmit}
                />

                <div className="form-group d-flex">
                  <button
                    type="submit"
                    className="btn btn-block btn-primary btn-xl w-100"
                    disabled={submitting}>
                    Save
                  </button>
                </div>
              </form>
            )}
          />
        </React.Fragment>
      )}
    </Subscribe>
  );
};

export { AddressUpdate };
